import TraitsListItems from './TraitsListItems'

export default TraitsListItems
